import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronRight, Flame } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SUB_ICONS = {
  handbags:'👜',watches:'⌚',sunglasses:'🕶️',belts:'🪢',wallets:'👛',scarves:'🧣',hats:'🎩',hair_acc:'💇‍♀️',jewelry_acc:'💎',keychains:'🔑',travel_acc:'🧳',umbrellas:'☂️',
  dresses:'👗',tops:'👚',pants:'👖',shoes:'👟',sportswear:'🏃',outerwear:'🧥',sleepwear:'🌙',swimwear:'👙',lingerie:'🩱',suits:'🤵',abayas:'🧕',activewear:'🏃‍♀️',socks:'🧦',
  skincare:'🧴',makeup:'💄',perfumes:'🌸',haircare:'💇',bodycare:'🛁',nailcare:'💅',shaving:'🪒',dental:'🪥',tools_beauty:'🪮',masks:'🧖',tanning:'☀️',
  necklaces:'📿',rings:'💍',earrings:'✨',bracelets:'⭕',anklets:'🦶',sets:'💎',brooches:'📌',pendants:'🔮',watches_jewelry:'⌚',hair_jewelry:'👸',body_chains:'⛓️',
  cameras:'📷',headphones:'🎧',speakers:'🔊',gaming_elec:'🎮',smarthome:'🏠',wearables:'⌚',tablets:'📱',laptops:'💻',monitors:'🖥️',printers:'🖨️',routers:'📶',batteries:'🔋',drones:'🛸',
  appliances:'🍳',cookware:'🥘',decor:'🖼️',bedding:'🛏️',storage:'📦',cleaning:'🧹',lighting:'💡',bathroom:'🚿',furniture:'🪑',rugs:'🏠',curtains:'🪟',garden_home:'🌱',candles:'🕯️',
  cases:'📱',protectors:'🛡️',chargers:'🔌',cables:'🔗',powerbanks:'🔋',holders:'📲',earphones:'🎧',smartwatches:'⌚',stands:'📐',screen_protectors:'📋',car_mounts:'🚗',
  fitness:'🏋️',yoga:'🧘',outdoor:'⛰️',team:'⚽',cycling:'🚴',swimming:'🏊',running:'🏃',camping:'⛺',fishing:'🎣',martial:'🥋',tennis:'🎾',basketball:'🏀',
  clothing_baby:'👶',toys:'🧸',care:'🍼',strollers:'🚼',feeding:'🥄',safety:'🔒',diapers:'🧷',school:'🎒',nursery:'🛏️',books_kids:'📖',puzzles:'🧩',outdoor_kids:'🛝',
  car_acc:'🚗',car_electronics:'📻',car_care:'🧽',tires:'🛞',car_interior:'💺',car_exterior:'🔧',car_audio:'🔊',car_lights:'💡',car_tools:'🔩',car_safety:'🦺',car_perfume:'🌲',
  novels:'📖',educational:'📚',notebooks:'📓',art_supplies:'🎨',pens:'🖊️',calendars:'📅',stickers:'🏷️',coloring:'🖍️',crafts:'✂️',frames:'🖼️',gifts_wrap:'🎁',office:'🗂️',
  // مكملات غذائية لكمال الأجسام
  whey_protein:'🥛',mass_gainer:'💪',vitamins_men:'💊',vitamins_women:'💊',creatine:'⚡',bcaa:'🧬',pre_workout:'🔥',fat_burner:'🔥',protein_bars:'🍫',omega_fish_oil:'🐟',
  dog:'🐕',cat:'🐈',fish:'🐟',pet_food:'🦴',pet_toys:'🎾',grooming:'✂️',aquarium:'🐠',bird:'🐦',reptile:'🦎',pet_beds:'🛏️',collars:'📿',
  plants:'🌱',furniture_out:'🪑',bbq:'🔥',garden_tools:'🌿',pots:'🪴',seeds:'🌻',irrigation:'💧',fencing:'🏗️',decor_out:'🏡',solar_lights:'☀️',hammocks:'🏖️',
  consoles:'🎮',games:'🕹️',gaming_acc:'🎧',vr:'🥽',controllers:'🕹️',gaming_chairs:'💺',streaming:'📺',pc_gaming:'💻',gaming_mice:'🖱️',keyboards:'⌨️',headsets:'🎙️',
  power_tools:'🔨',hand_tools:'🪛',plumbing:'🚰',electrical:'⚡',paint:'🎨',measuring:'📏',ladders:'🪜',safety_tools:'🥽',fasteners:'🔩',tape:'📎',workbench:'🪚',storage_tools:'🧰',
};

// Comprehensive category structure like major e-commerce platforms
export const CATEGORY_STRUCTURE = {
  accessories: {
    name: 'Accessories',
    name_ar: 'اكسسوارات',
    icon: '👜',
    subcategories: [
      { key: 'handbags', name: 'Handbags', name_ar: 'حقائب يد', hasGender: true },
      { key: 'watches', name: 'Watches', name_ar: 'ساعات', hasGender: true },
      { key: 'sunglasses', name: 'Sunglasses', name_ar: 'نظارات شمسية', hasGender: true },
      { key: 'belts', name: 'Belts', name_ar: 'أحزمة', hasGender: true },
      { key: 'wallets', name: 'Wallets', name_ar: 'محافظ', hasGender: true },
      { key: 'scarves', name: 'Scarves & Shawls', name_ar: 'أوشحة وشالات', hasGender: true },
      { key: 'hats', name: 'Hats & Caps', name_ar: 'قبعات', hasGender: true },
      { key: 'hair_acc', name: 'Hair Accessories', name_ar: 'إكسسوارات شعر', hasGender: false },
      { key: 'jewelry_acc', name: 'Fashion Jewelry', name_ar: 'مجوهرات أزياء', hasGender: true },
      { key: 'keychains', name: 'Keychains', name_ar: 'ميداليات مفاتيح', hasGender: false },
      { key: 'travel_acc', name: 'Travel Accessories', name_ar: 'إكسسوارات سفر', hasGender: false },
      { key: 'umbrellas', name: 'Umbrellas', name_ar: 'مظلات', hasGender: false },
    ],
    categoryMapping: { women: 'accessories', men: 'men_accessories' }
  },
  fashion: {
    name: 'Fashion',
    name_ar: 'أزياء',
    icon: '👗',
    subcategories: [
      { key: 'dresses', name: 'Dresses', name_ar: 'فساتين', hasGender: false },
      { key: 'tops', name: 'Tops & Blouses', name_ar: 'بلايز وقمصان', hasGender: true },
      { key: 'pants', name: 'Pants & Jeans', name_ar: 'بناطيل وجينز', hasGender: true },
      { key: 'shoes', name: 'Shoes', name_ar: 'أحذية', hasGender: true },
      { key: 'sportswear', name: 'Sportswear', name_ar: 'ملابس رياضية', hasGender: true },
      { key: 'outerwear', name: 'Outerwear & Jackets', name_ar: 'جاكيتات ومعاطف', hasGender: true },
      { key: 'sleepwear', name: 'Sleepwear', name_ar: 'ملابس نوم', hasGender: true },
      { key: 'swimwear', name: 'Swimwear', name_ar: 'ملابس سباحة', hasGender: true },
      { key: 'suits', name: 'Suits & Formal', name_ar: 'بدلات وملابس رسمية', hasGender: true },
      { key: 'abayas', name: 'Abayas & Modest', name_ar: 'عبايات ومحتشم', hasGender: false },
      { key: 'activewear', name: 'Activewear', name_ar: 'ملابس نشاط', hasGender: true },
      { key: 'socks', name: 'Socks & Underwear', name_ar: 'جوارب وملابس داخلية', hasGender: true },
      { key: 'lingerie', name: 'Lingerie', name_ar: 'ملابس داخلية نسائية', hasGender: false },
    ],
    categoryMapping: { women: 'fashion', men: 'men_fashion' }
  },
  beauty: {
    name: 'Beauty & Care',
    name_ar: 'جمال وعناية',
    icon: '💄',
    subcategories: [
      { key: 'skincare', name: 'Skincare', name_ar: 'العناية بالبشرة', hasGender: true },
      { key: 'makeup', name: 'Makeup', name_ar: 'مكياج', hasGender: false },
      { key: 'perfumes', name: 'Perfumes', name_ar: 'عطور', hasGender: true },
      { key: 'haircare', name: 'Hair Care', name_ar: 'العناية بالشعر', hasGender: true },
      { key: 'bodycare', name: 'Body Care', name_ar: 'العناية بالجسم', hasGender: true },
      { key: 'nailcare', name: 'Nail Care', name_ar: 'العناية بالأظافر', hasGender: false },
      { key: 'shaving', name: 'Shaving & Grooming', name_ar: 'حلاقة وعناية', hasGender: true },
      { key: 'dental', name: 'Dental Care', name_ar: 'العناية بالأسنان', hasGender: false },
      { key: 'tools_beauty', name: 'Beauty Tools', name_ar: 'أدوات تجميل', hasGender: false },
      { key: 'masks', name: 'Face Masks', name_ar: 'أقنعة وجه', hasGender: false },
      { key: 'tanning', name: 'Tanning & Sun Care', name_ar: 'حماية من الشمس', hasGender: false },
    ],
    categoryMapping: { women: 'beauty', men: 'men_beauty' }
  },
  jewelry: {
    name: 'Jewelry',
    name_ar: 'مجوهرات',
    icon: '💎',
    subcategories: [
      { key: 'necklaces', name: 'Necklaces', name_ar: 'قلائد', hasGender: false },
      { key: 'rings', name: 'Rings', name_ar: 'خواتم', hasGender: false },
      { key: 'earrings', name: 'Earrings', name_ar: 'أقراط', hasGender: false },
      { key: 'bracelets', name: 'Bracelets', name_ar: 'أساور', hasGender: false },
      { key: 'anklets', name: 'Anklets', name_ar: 'خلاخيل', hasGender: false },
      { key: 'sets', name: 'Jewelry Sets', name_ar: 'طقم مجوهرات', hasGender: false }
    ],
    categoryMapping: { default: 'jewelry' }
  },
  electronics: {
    name: 'Electronics',
    name_ar: 'الكترونيات',
    icon: '📱',
    subcategories: [
      { key: 'cameras', name: 'Cameras & Photography', name_ar: 'كاميرات وتصوير', hasGender: false },
      { key: 'headphones', name: 'Headphones', name_ar: 'سماعات', hasGender: false },
      { key: 'speakers', name: 'Speakers & Audio', name_ar: 'مكبرات صوت', hasGender: false },
      { key: 'gaming_elec', name: 'Gaming Electronics', name_ar: 'إلكترونيات ألعاب', hasGender: false },
      { key: 'smarthome', name: 'Smart Home', name_ar: 'منزل ذكي', hasGender: false },
      { key: 'wearables', name: 'Wearables', name_ar: 'أجهزة ملبوسة', hasGender: false },
      { key: 'tablets', name: 'Tablets & iPads', name_ar: 'تابلت وآيباد', hasGender: false },
      { key: 'laptops', name: 'Laptops', name_ar: 'لابتوبات', hasGender: false },
      { key: 'monitors', name: 'Monitors & Screens', name_ar: 'شاشات', hasGender: false },
      { key: 'printers', name: 'Printers & Scanners', name_ar: 'طابعات', hasGender: false },
      { key: 'routers', name: 'Networking & WiFi', name_ar: 'شبكات وواي فاي', hasGender: false },
      { key: 'batteries', name: 'Batteries & Power', name_ar: 'بطاريات وطاقة', hasGender: false },
      { key: 'drones', name: 'Drones', name_ar: 'طائرات مسيرة', hasGender: false },
    ],
    categoryMapping: { default: 'electronics' }
  },
  home: {
    name: 'Home & Kitchen',
    name_ar: 'المنزل والمطبخ',
    icon: '🏠',
    subcategories: [
      { key: 'appliances', name: 'Kitchen Appliances', name_ar: 'أجهزة مطبخ', hasGender: false },
      { key: 'cookware', name: 'Cookware & Bakeware', name_ar: 'أواني طهي', hasGender: false },
      { key: 'decor', name: 'Home Décor', name_ar: 'ديكور منزلي', hasGender: false },
      { key: 'bedding', name: 'Bedding & Linen', name_ar: 'مفروشات', hasGender: false },
      { key: 'storage', name: 'Storage & Organization', name_ar: 'تخزين وتنظيم', hasGender: false },
      { key: 'cleaning', name: 'Cleaning Supplies', name_ar: 'مواد تنظيف', hasGender: false },
      { key: 'lighting', name: 'Lighting', name_ar: 'إضاءة', hasGender: false },
      { key: 'bathroom', name: 'Bathroom Accessories', name_ar: 'إكسسوارات حمام', hasGender: false },
      { key: 'furniture', name: 'Small Furniture', name_ar: 'أثاث صغير', hasGender: false },
      { key: 'rugs', name: 'Rugs & Carpets', name_ar: 'سجاد', hasGender: false },
      { key: 'curtains', name: 'Curtains & Blinds', name_ar: 'ستائر', hasGender: false },
      { key: 'candles', name: 'Candles & Fragrances', name_ar: 'شموع ومعطرات', hasGender: false },
    ],
    categoryMapping: { default: 'home' }
  },
  phones: {
    name: 'Phones & Tablets',
    name_ar: 'هواتف وأجهزة',
    icon: '📲',
    subcategories: [
      { key: 'cases', name: 'Phone Cases', name_ar: 'أغطية هواتف', hasGender: false },
      { key: 'protectors', name: 'Screen Protectors', name_ar: 'واقيات شاشة', hasGender: false },
      { key: 'chargers', name: 'Chargers', name_ar: 'شواحن', hasGender: false },
      { key: 'cables', name: 'Cables', name_ar: 'كابلات', hasGender: false },
      { key: 'powerbanks', name: 'Power Banks', name_ar: 'بطاريات محمولة', hasGender: false },
      { key: 'holders', name: 'Phone Holders', name_ar: 'حوامل هواتف', hasGender: false }
    ],
    categoryMapping: { default: 'phones' }
  },
  sports: {
    name: 'Sports & Fitness',
    name_ar: 'رياضة ولياقة',
    icon: '⚽',
    subcategories: [
      { key: 'fitness', name: 'Fitness Equipment', name_ar: 'معدات لياقة', hasGender: false },
      { key: 'yoga', name: 'Yoga & Pilates', name_ar: 'يوغا وبيلاتيس', hasGender: false },
      { key: 'outdoor', name: 'Outdoor & Hiking', name_ar: 'هايكنج ومغامرات', hasGender: false },
      { key: 'team', name: 'Team Sports', name_ar: 'رياضات جماعية', hasGender: false },
      { key: 'cycling', name: 'Cycling', name_ar: 'دراجات', hasGender: false },
      { key: 'swimming', name: 'Swimming', name_ar: 'سباحة', hasGender: false },
      { key: 'running', name: 'Running', name_ar: 'جري', hasGender: true },
      { key: 'camping', name: 'Camping & Outdoors', name_ar: 'تخييم', hasGender: false },
      { key: 'fishing', name: 'Fishing', name_ar: 'صيد', hasGender: false },
      { key: 'martial', name: 'Martial Arts', name_ar: 'فنون قتالية', hasGender: false },
      { key: 'tennis', name: 'Tennis & Racket', name_ar: 'تنس ومضرب', hasGender: false },
      { key: 'basketball', name: 'Basketball', name_ar: 'كرة سلة', hasGender: false },
    ],
    categoryMapping: { default: 'sports' }
  },
  baby: {
    name: 'Baby & Kids',
    name_ar: 'أطفال ورضع',
    icon: '👶',
    subcategories: [
      { key: 'clothing', name: 'Baby Clothing', name_ar: 'ملابس أطفال', hasGender: false },
      { key: 'toys', name: 'Toys', name_ar: 'ألعاب', hasGender: false },
      { key: 'care', name: 'Baby Care', name_ar: 'عناية الطفل', hasGender: false },
      { key: 'strollers', name: 'Strollers', name_ar: 'عربات أطفال', hasGender: false },
      { key: 'feeding', name: 'Feeding', name_ar: 'تغذية', hasGender: false },
      { key: 'safety', name: 'Safety', name_ar: 'أمان', hasGender: false }
    ],
    categoryMapping: { default: 'baby' }
  },
  automotive: {
    name: 'Automotive',
    name_ar: 'سيارات',
    icon: '🚗',
    subcategories: [
      { key: 'car_acc', name: 'Car Accessories', name_ar: 'إكسسوارات سيارات', hasGender: false },
      { key: 'car_electronics', name: 'Car Electronics', name_ar: 'إلكترونيات السيارة', hasGender: false },
      { key: 'car_care', name: 'Car Care & Wash', name_ar: 'عناية وغسيل', hasGender: false },
      { key: 'tires', name: 'Tires & Wheels', name_ar: 'إطارات وجنوط', hasGender: false },
      { key: 'car_interior', name: 'Interior Accessories', name_ar: 'إكسسوارات داخلية', hasGender: false },
      { key: 'car_exterior', name: 'Exterior Parts', name_ar: 'قطع خارجية', hasGender: false },
      { key: 'car_audio', name: 'Car Audio', name_ar: 'أنظمة صوت', hasGender: false },
      { key: 'car_lights', name: 'Lights & LEDs', name_ar: 'إضاءة وليد', hasGender: false },
      { key: 'car_tools', name: 'Car Tools', name_ar: 'أدوات السيارة', hasGender: false },
      { key: 'car_safety', name: 'Safety & Emergency', name_ar: 'سلامة وطوارئ', hasGender: false },
      { key: 'car_perfume', name: 'Car Fresheners', name_ar: 'معطرات السيارة', hasGender: false },
    ],
    categoryMapping: { default: 'automotive' }
  },
  books: {
    name: 'Books & Stationery',
    name_ar: 'كتب وقرطاسية',
    icon: '📚',
    subcategories: [
      { key: 'novels', name: 'Novels & Fiction', name_ar: 'روايات وقصص', hasGender: false },
      { key: 'educational', name: 'Educational', name_ar: 'تعليمية', hasGender: false },
      { key: 'notebooks', name: 'Notebooks & Planners', name_ar: 'دفاتر ومخططات', hasGender: false },
      { key: 'art_supplies', name: 'Art Supplies', name_ar: 'أدوات فنية', hasGender: false },
      { key: 'pens', name: 'Pens & Writing', name_ar: 'أقلام وكتابة', hasGender: false },
      { key: 'calendars', name: 'Calendars & Diaries', name_ar: 'تقاويم ومفكرات', hasGender: false },
      { key: 'stickers', name: 'Stickers & Labels', name_ar: 'ملصقات', hasGender: false },
      { key: 'coloring', name: 'Coloring Books', name_ar: 'كتب تلوين', hasGender: false },
      { key: 'crafts', name: 'Crafts & DIY', name_ar: 'أشغال يدوية', hasGender: false },
      { key: 'frames', name: 'Photo Frames', name_ar: 'إطارات صور', hasGender: false },
      { key: 'gifts_wrap', name: 'Gift Wrapping', name_ar: 'تغليف هدايا', hasGender: false },
      { key: 'office', name: 'Office Supplies', name_ar: 'مستلزمات مكتبية', hasGender: false },
    ],
    categoryMapping: { default: 'stationery' }
  },
  supplements: {
    name: 'Bodybuilding Supplements',
    name_ar: 'مكملات غذائية',
    icon: '💪',
    subcategories: [
      { key: 'whey_protein', name: 'Whey Protein', name_ar: 'بروتين واي', hasGender: false },
      { key: 'mass_gainer', name: 'Mass Gainer', name_ar: 'جينر (زيادة الوزن)', hasGender: false },
      { key: 'vitamins_men', name: "Men's Vitamins", name_ar: 'فيتامينات رجالية', hasGender: false },
      { key: 'vitamins_women', name: "Women's Vitamins", name_ar: 'فيتامينات نسائية', hasGender: false },
      { key: 'creatine', name: 'Creatine', name_ar: 'كرياتين', hasGender: false },
      { key: 'bcaa', name: 'BCAA & Amino Acids', name_ar: 'أحماض أمينية BCAA', hasGender: false },
      { key: 'pre_workout', name: 'Pre-Workout', name_ar: 'بري وورك أوت', hasGender: false },
      { key: 'fat_burner', name: 'Fat Burners', name_ar: 'حوارق الدهون', hasGender: false },
      { key: 'protein_bars', name: 'Protein Bars & Snacks', name_ar: 'ألواح وسناكات بروتين', hasGender: false },
      { key: 'omega_fish_oil', name: 'Omega & Fish Oil', name_ar: 'أوميغا وزيت السمك', hasGender: false },
    ],
    categoryMapping: { default: 'supplements' }
  },
  pets: {
    name: 'Pets',
    name_ar: 'حيوانات أليفة',
    icon: '🐾',
    subcategories: [
      { key: 'dog', name: 'Dogs', name_ar: 'كلاب', hasGender: false },
      { key: 'cat', name: 'Cats', name_ar: 'قطط', hasGender: false },
      { key: 'fish', name: 'Fish & Aquariums', name_ar: 'أسماك وأحواض', hasGender: false },
      { key: 'pet_food', name: 'Pet Food & Treats', name_ar: 'طعام وحلوى', hasGender: false },
      { key: 'pet_toys', name: 'Pet Toys', name_ar: 'ألعاب حيوانات', hasGender: false },
      { key: 'grooming', name: 'Grooming & Hygiene', name_ar: 'عناية ونظافة', hasGender: false },
      { key: 'aquarium', name: 'Aquarium Supplies', name_ar: 'مستلزمات أحواض', hasGender: false },
      { key: 'bird', name: 'Birds', name_ar: 'طيور', hasGender: false },
      { key: 'reptile', name: 'Reptiles & Exotic', name_ar: 'زواحف ونادرة', hasGender: false },
      { key: 'pet_beds', name: 'Pet Beds & Houses', name_ar: 'أسرّة وبيوت', hasGender: false },
      { key: 'collars', name: 'Collars & Leashes', name_ar: 'أطواق ومقاود', hasGender: false },
    ],
    categoryMapping: { default: 'pets' }
  },
  garden: {
    name: 'Garden & Outdoor',
    name_ar: 'حديقة وهواء طلق',
    icon: '🌿',
    subcategories: [
      { key: 'plants', name: 'Plants & Seeds', name_ar: 'نباتات وبذور', hasGender: false },
      { key: 'furniture_out', name: 'Outdoor Furniture', name_ar: 'أثاث خارجي', hasGender: false },
      { key: 'bbq', name: 'BBQ & Grills', name_ar: 'شواء ومشاوي', hasGender: false },
      { key: 'garden_tools', name: 'Garden Tools', name_ar: 'أدوات حديقة', hasGender: false },
      { key: 'pots', name: 'Pots & Planters', name_ar: 'أحواض وأصص', hasGender: false },
      { key: 'seeds', name: 'Seeds & Bulbs', name_ar: 'بذور وأبصال', hasGender: false },
      { key: 'irrigation', name: 'Irrigation & Watering', name_ar: 'ري وسقاية', hasGender: false },
      { key: 'fencing', name: 'Fencing & Gates', name_ar: 'أسوار وبوابات', hasGender: false },
      { key: 'decor_out', name: 'Garden Décor', name_ar: 'ديكور حديقة', hasGender: false },
      { key: 'solar_lights', name: 'Solar & Outdoor Lights', name_ar: 'إضاءة شمسية', hasGender: false },
      { key: 'hammocks', name: 'Hammocks & Swings', name_ar: 'أراجيح', hasGender: false },
    ],
    categoryMapping: { default: 'garden' }
  },
  gaming: {
    name: 'Gaming',
    name_ar: 'ألعاب فيديو',
    icon: '🎮',
    subcategories: [
      { key: 'consoles', name: 'Consoles', name_ar: 'أجهزة ألعاب', hasGender: false },
      { key: 'games', name: 'Video Games', name_ar: 'ألعاب فيديو', hasGender: false },
      { key: 'gaming_acc', name: 'Gaming Accessories', name_ar: 'إكسسوارات ألعاب', hasGender: false },
      { key: 'vr', name: 'VR & AR Headsets', name_ar: 'نظارات واقع افتراضي', hasGender: false },
      { key: 'controllers', name: 'Controllers & Gamepads', name_ar: 'أذرع تحكم', hasGender: false },
      { key: 'gaming_chairs', name: 'Gaming Chairs', name_ar: 'كراسي ألعاب', hasGender: false },
      { key: 'streaming', name: 'Streaming Equipment', name_ar: 'معدات بث', hasGender: false },
      { key: 'pc_gaming', name: 'PC Gaming', name_ar: 'ألعاب كمبيوتر', hasGender: false },
      { key: 'gaming_mice', name: 'Gaming Mice', name_ar: 'فأرات ألعاب', hasGender: false },
      { key: 'keyboards', name: 'Gaming Keyboards', name_ar: 'كيبورد ألعاب', hasGender: false },
      { key: 'headsets', name: 'Gaming Headsets', name_ar: 'سماعات ألعاب', hasGender: false },
    ],
    categoryMapping: { default: 'gaming' }
  },
  tools: {
    name: 'Tools & Hardware',
    name_ar: 'أدوات ومعدات',
    icon: '🔧',
    subcategories: [
      { key: 'power_tools', name: 'Power Tools', name_ar: 'أدوات كهربائية', hasGender: false },
      { key: 'hand_tools', name: 'Hand Tools', name_ar: 'أدوات يدوية', hasGender: false },
      { key: 'plumbing', name: 'Plumbing', name_ar: 'سباكة', hasGender: false },
      { key: 'electrical', name: 'Electrical', name_ar: 'كهرباء', hasGender: false },
      { key: 'paint', name: 'Paint & Supplies', name_ar: 'دهانات ولوازم', hasGender: false },
      { key: 'measuring', name: 'Measuring Tools', name_ar: 'أدوات قياس', hasGender: false },
      { key: 'ladders', name: 'Ladders & Scaffolding', name_ar: 'سلالم وسقالات', hasGender: false },
      { key: 'safety_tools', name: 'Safety Gear', name_ar: 'معدات سلامة', hasGender: false },
      { key: 'fasteners', name: 'Fasteners & Screws', name_ar: 'مسامير وبراغي', hasGender: false },
      { key: 'tape', name: 'Tape & Adhesives', name_ar: 'شريط ولاصق', hasGender: false },
      { key: 'workbench', name: 'Workbench & Saws', name_ar: 'مناشير وطاولات عمل', hasGender: false },
      { key: 'storage_tools', name: 'Tool Storage', name_ar: 'تخزين أدوات', hasGender: false },
    ],
    categoryMapping: { default: 'tools' }
  }
};

export default function CategoryMegaMenu({ isRTL, onCategorySelect, currentCategory, layout, parentKey }) {
  const [activeCategory, setActiveCategory] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileActiveCategory, setMobileActiveCategory] = useState(null);
  const [mobileExpandedSubcat, setMobileExpandedSubcat] = useState(null);
  const [counts, setCounts] = useState({});
  const [previews, setPreviews] = useState({});
  const [hoveredSubcat, setHoveredSubcat] = useState(null);
  const [bestSeller, setBestSeller] = useState(null);
  const closeTimer = React.useRef(null);

  const handleMenuEnter = (key) => {
    clearTimeout(closeTimer.current);
    setActiveCategory(key);
  };
  const handleMenuLeave = () => {
    closeTimer.current = setTimeout(() => {
      setActiveCategory(null);
      setHoveredSubcat(null);
    }, 120);
  };

  useEffect(() => {
    // Fetch product counts per sub_category and find best seller
    fetch(`${API_URL}/api/products?limit=1000`)
      .then(r => r.json())
      .then(data => {
        const products = data.products || [];
        const countMap = {};
        const previewMap = {};
        const subcatSales = {};

        products.forEach(p => {
          const key = `${p.category}_${p.subcategory || p.sub_category || 'all'}_${p.gender || 'all'}`;
          const subKey = p.subcategory || p.sub_category || 'all';
          countMap[key] = (countMap[key] || 0) + 1;

          if (!previewMap[subKey]) previewMap[subKey] = [];
          if (previewMap[subKey].length < 3) previewMap[subKey].push(p.image);

          subcatSales[subKey] = (subcatSales[subKey] || 0) + (p.sold_count || 0);
        });

        setCounts(countMap);
        setPreviews(previewMap);

        // Find best seller subcategory
        let topSub = null, topSales = 0;
        Object.entries(subcatSales).forEach(([k, v]) => {
          if (v > topSales) { topSales = v; topSub = k; }
        });
        setBestSeller(topSub);
      })
      .catch(() => {});
  }, []);

  const getCount = (category, subcat, gender) => {
    const genderNorm = gender === 'women' ? 'female' : gender === 'men' ? 'male' : gender;
    const key = `${category}_${subcat || 'all'}_${genderNorm || 'all'}`;
    const key2 = `${category}_${subcat || 'all'}_${gender || 'all'}`;
    return counts[key] || counts[key2] || 0;
  };

  const handleCategoryClick = (categoryKey, subcatKey, gender = null) => {
    const category = CATEGORY_STRUCTURE[categoryKey];
    let targetCategory;
    
    if (gender && category.categoryMapping[gender]) {
      targetCategory = category.categoryMapping[gender];
    } else if (category.categoryMapping.default) {
      targetCategory = category.categoryMapping.default;
    } else {
      targetCategory = category.categoryMapping.women || Object.values(category.categoryMapping)[0];
    }
    
    onCategorySelect(targetCategory, subcatKey, gender);
    setActiveCategory(null);
    setHoveredSubcat(null);
  };

  const handleAllClick = () => {
    onCategorySelect('', null, null);
    setActiveCategory(null);
    setMobileMenuOpen(false);
    setMobileActiveCategory(null);
    setMobileExpandedSubcat(null);
  };

  const handleMobileCategoryClick = (categoryKey, subcatKey, gender = null) => {
    handleCategoryClick(categoryKey, subcatKey, gender);
    setMobileMenuOpen(false);
    setMobileActiveCategory(null);
    setMobileExpandedSubcat(null);
  };

  // Mobile subcategories for sidebar layout
  if (layout === 'mobile-sub' && parentKey) {
    const cat = CATEGORY_STRUCTURE[parentKey];
    if (!cat || !cat.subcategories) return <div className="p-4 text-sm text-muted-foreground">No subcategories</div>;
    return cat.subcategories.map(sub => (
      <div key={sub.key}>
        <button onClick={() => {
          if (sub.hasGender) {
            setMobileExpandedSubcat(mobileExpandedSubcat === sub.key ? null : sub.key);
          }
          onCategorySelect(parentKey, sub.key, '');
        }}
          className="w-full px-3 py-2 text-[10px] text-muted-foreground hover:text-primary hover:bg-primary/5 flex items-center gap-1 border-b border-border/30 transition-colors">
          <span className="text-xs">{SUB_ICONS[sub.key] || '•'}</span>
          <span>{isRTL ? sub.name_ar : sub.name}</span>
        </button>
        {sub.hasGender && mobileExpandedSubcat === sub.key && (
          <div className="flex gap-1 px-3 py-1.5 bg-secondary/20">
            <button onClick={() => {
              const cat = CATEGORY_STRUCTURE[parentKey];
              const mapped = cat?.categoryMapping?.women || parentKey;
              onCategorySelect(mapped, sub.key, 'women');
            }} className="text-[9px] px-2 py-0.5 rounded-full bg-pink-500/10 text-pink-500">{isRTL ? 'نسائي' : 'Women'}</button>
            <button onClick={() => {
              const cat = CATEGORY_STRUCTURE[parentKey];
              const mapped = cat?.categoryMapping?.men || parentKey;
              onCategorySelect(mapped, sub.key, 'men');
            }} className="text-[9px] px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-500">{isRTL ? 'رجالي' : 'Men'}</button>
          </div>
        )}
      </div>
    ));
  }

  return (
    <div className="w-full">
      {/* Mobile: Single Button + Dropdown */}
      <div className="md:hidden">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="w-full px-4 py-3 bg-white dark:bg-gray-800 rounded-xl border-2 border-gray-200 dark:border-gray-600 flex items-center justify-between shadow-sm"
        >
          <span className="flex items-center gap-2 text-gray-700 dark:text-gray-200 font-semibold">
            <span>🏷️</span>
            {isRTL ? 'تصفية الفئات' : 'Browse Categories'}
          </span>
          <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform ${mobileMenuOpen ? 'rotate-180' : ''}`} />
        </button>

        {/* Mobile Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="mt-2 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-xl overflow-hidden max-h-[70vh] overflow-y-auto">
            {/* All Products Button */}
            <button
              onClick={handleAllClick}
              className={`w-full px-4 py-3 text-right flex items-center gap-3 border-b border-gray-100 dark:border-gray-700 ${
                !currentCategory ? 'bg-[hsl(var(--ss-teal))]/10 text-[hsl(var(--ss-teal))]' : 'text-gray-700 dark:text-gray-200'
              }`}
            >
              <span className="text-lg">✨</span>
              <span className="font-semibold">{isRTL ? 'كل المنتجات' : 'All Products'}</span>
            </button>

            {/* Categories List */}
            {Object.entries(CATEGORY_STRUCTURE).map(([key, category]) => (
              <div key={key} className="border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                {/* Category Header */}
                <button
                  onClick={() => setMobileActiveCategory(mobileActiveCategory === key ? null : key)}
                  className={`w-full px-4 py-3 flex items-center justify-between ${
                    mobileActiveCategory === key ? 'bg-gray-50 dark:bg-gray-700' : ''
                  }`}
                >
                  <span className="flex items-center gap-3 text-gray-700 dark:text-gray-200">
                    <span className="text-lg">{category.icon}</span>
                    <span className="font-semibold">{isRTL ? category.name_ar : category.name}</span>
                  </span>
                  <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${mobileActiveCategory === key ? 'rotate-180' : ''}`} />
                </button>

                {/* Subcategories */}
                {mobileActiveCategory === key && (
                  <div className="bg-gray-50 dark:bg-gray-900/50">
                    {/* Quick Gender Buttons for categories with gender */}
                    {category.categoryMapping.women && category.categoryMapping.men && (
                      <div className="flex gap-2 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                        <button
                          onClick={() => handleMobileCategoryClick(key, null, 'women')}
                          className="flex-1 px-3 py-2 rounded-lg text-xs font-bold bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300 flex items-center justify-center gap-1"
                        >
                          <span className="w-2 h-2 rounded-full bg-pink-500"></span>
                          {isRTL ? 'كل النسائي' : "All Women's"}
                        </button>
                        <button
                          onClick={() => handleMobileCategoryClick(key, null, 'men')}
                          className="flex-1 px-3 py-2 rounded-lg text-xs font-bold bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 flex items-center justify-center gap-1"
                        >
                          <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                          {isRTL ? 'كل الرجالي' : "All Men's"}
                        </button>
                      </div>
                    )}

                    {/* Subcategory List */}
                    {category.subcategories.map((subcat) => (
                      <div key={subcat.key}>
                        <button
                          onClick={() => {
                            if (subcat.hasGender) {
                              setMobileExpandedSubcat(mobileExpandedSubcat === subcat.key ? null : subcat.key);
                            } else {
                              const gender = subcat.gender || 'default';
                              handleMobileCategoryClick(key, subcat.key, gender === 'default' ? null : gender);
                            }
                          }}
                          className={`w-full px-6 py-2.5 flex items-center justify-between text-sm ${
                            mobileExpandedSubcat === subcat.key ? 'bg-[hsl(var(--ss-teal))]/10' : ''
                          }`}
                        >
                          <span className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                            {subcat.gender === 'women' && !subcat.hasGender && <span className="w-2 h-2 rounded-full bg-pink-400"></span>}
                            {subcat.gender === 'men' && !subcat.hasGender && <span className="w-2 h-2 rounded-full bg-blue-400"></span>}
                            {isRTL ? subcat.name_ar : subcat.name}
                          </span>
                          {subcat.hasGender && (
                            <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${mobileExpandedSubcat === subcat.key ? 'rotate-180' : ''}`} />
                          )}
                        </button>

                        {/* Gender Options */}
                        {subcat.hasGender && mobileExpandedSubcat === subcat.key && (
                          <div className="bg-white dark:bg-gray-800 mx-4 mb-2 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-600">
                            <button
                              onClick={() => handleMobileCategoryClick(key, subcat.key, 'women')}
                              className="w-full px-4 py-2.5 flex items-center gap-2 text-sm hover:bg-pink-50 dark:hover:bg-pink-900/20 border-b border-gray-100 dark:border-gray-700"
                            >
                              <span className="w-2.5 h-2.5 rounded-full bg-pink-500"></span>
                              <span className="text-gray-700 dark:text-gray-200">{isRTL ? 'نسائي' : "Women's"}</span>
                            </button>
                            <button
                              onClick={() => handleMobileCategoryClick(key, subcat.key, 'men')}
                              className="w-full px-4 py-2.5 flex items-center gap-2 text-sm hover:bg-blue-50 dark:hover:bg-blue-900/20"
                            >
                              <span className="w-2.5 h-2.5 rounded-full bg-blue-500"></span>
                              <span className="text-gray-700 dark:text-gray-200">{isRTL ? 'رجالي' : "Men's"}</span>
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Desktop: Original Button Layout */}
      <div className="hidden md:block">
        <div className="flex flex-wrap justify-center gap-2 mb-2">
        {/* All Button */}
        <button
          onClick={handleAllClick}
          data-testid="mega-menu-all-btn"
          className={`
            px-5 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 border-2
            ${!currentCategory 
              ? 'bg-[hsl(var(--ss-teal))] text-white border-[hsl(var(--ss-teal))] shadow-lg' 
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600 hover:border-[hsl(var(--ss-teal))] hover:text-[hsl(var(--ss-teal))]'
            }
          `}
        >
          {isRTL ? 'الكل' : 'All'}
        </button>

        {/* Category Buttons */}
        {Object.entries(CATEGORY_STRUCTURE).map(([key, category]) => (
          <div 
            key={key}
            className="relative"
            onMouseEnter={() => handleMenuEnter(key)}
            onMouseLeave={handleMenuLeave}
          >
            <button
              onClick={() => setActiveCategory(activeCategory === key ? null : key)}
              data-testid={`mega-menu-category-${key}`}
              className={`
                px-5 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 border-2 flex items-center gap-2
                ${currentCategory && (
                  currentCategory === category.categoryMapping?.default ||
                  currentCategory === category.categoryMapping?.women ||
                  currentCategory === category.categoryMapping?.men
                )
                  ? 'bg-[hsl(var(--ss-teal))] text-white border-[hsl(var(--ss-teal))] shadow-lg' 
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600 hover:border-[hsl(var(--ss-teal))] hover:text-[hsl(var(--ss-teal))]'
                }
              `}
            >
              <span>{category.icon}</span>
              <span>{isRTL ? category.name_ar : category.name}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${activeCategory === key ? 'rotate-180' : ''}`} />
            </button>

            {/* Mega Menu Dropdown */}
            {activeCategory === key && (
              <div 
                className={`
                  absolute top-full z-50 
                  ${isRTL ? 'right-0' : 'left-0'}
                `}
                style={{ paddingTop: '4px' }}
              >
                <div className="relative flex gap-2">
                  {/* Main Subcategories Panel */}
                  <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 min-w-[320px]">
                    {/* Category Header */}
                    <div className="bg-gradient-to-r from-[hsl(var(--ss-teal))] to-emerald-600 px-4 py-3 rounded-t-2xl">
                      <h3 className="text-white font-bold text-lg flex items-center gap-2">
                        <span>{category.icon}</span>
                        {isRTL ? category.name_ar : category.name}
                      </h3>
                    </div>

                    {/* Subcategories List */}
                    <div className="py-1 max-h-[420px] overflow-y-auto">
                      {category.subcategories.map((subcat) => {
                        const icon = SUB_ICONS[subcat.key] || '•';
                        const isBest = bestSeller === subcat.key;
                        const catMapping = subcat.hasGender ? (category.categoryMapping.women || '') : (category.categoryMapping.default || category.categoryMapping.women || '');
                        const womenCount = getCount(category.categoryMapping.women || catMapping, subcat.key, 'women');
                        const menCount = getCount(category.categoryMapping.men || catMapping, subcat.key, 'men');

                        return (
                          <div
                            key={subcat.key}
                            data-testid={`mega-menu-subcategory-${subcat.key}`}
                            onMouseEnter={() => setHoveredSubcat(subcat.key)}
                            className="relative"
                          >
                            {subcat.hasGender ? (
                              <div className="px-4 py-2.5 flex items-center justify-between gap-2 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                                <span className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-200">
                                  <span className="text-base">{icon}</span>
                                  {isRTL ? subcat.name_ar : subcat.name}
                                  {isBest && (
                                    <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 text-[9px] font-bold">
                                      <Flame className="w-2.5 h-2.5" />{isRTL ? 'الأكثر' : 'HOT'}
                                    </span>
                                  )}
                                </span>
                                <div className="flex items-center gap-1.5 flex-shrink-0">
                                  <button
                                    onClick={() => handleCategoryClick(key, subcat.key, 'women')}
                                    data-testid={`gender-option-women-${subcat.key}`}
                                    className="px-2.5 py-1 rounded-lg text-[11px] font-bold bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-300 hover:bg-pink-200 dark:hover:bg-pink-800/40 transition-colors flex items-center gap-1"
                                  >
                                    <span className="w-1.5 h-1.5 rounded-full bg-pink-500"></span>
                                    {isRTL ? 'نسائي' : 'Women'}
                                    {womenCount > 0 && <span className="opacity-60">({womenCount})</span>}
                                  </button>
                                  <button
                                    onClick={() => handleCategoryClick(key, subcat.key, 'men')}
                                    data-testid={`gender-option-men-${subcat.key}`}
                                    className="px-2.5 py-1 rounded-lg text-[11px] font-bold bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800/40 transition-colors flex items-center gap-1"
                                  >
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                                    {isRTL ? 'رجالي' : 'Men'}
                                    {menCount > 0 && <span className="opacity-60">({menCount})</span>}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <button
                                onClick={() => {
                                  const g = subcat.gender || 'default';
                                  handleCategoryClick(key, subcat.key, g === 'default' ? null : g);
                                }}
                                className="w-full px-4 py-2.5 text-sm font-medium transition-colors hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 flex items-center justify-between"
                              >
                                <span className="flex items-center gap-2">
                                  <span className="text-base">{icon}</span>
                                  {subcat.gender === 'women' && <span className="w-1.5 h-1.5 rounded-full bg-pink-400"></span>}
                                  {subcat.gender === 'men' && <span className="w-1.5 h-1.5 rounded-full bg-blue-400"></span>}
                                  {isRTL ? subcat.name_ar : subcat.name}
                                  {isBest && (
                                    <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 text-[9px] font-bold">
                                      <Flame className="w-2.5 h-2.5" />{isRTL ? 'الأكثر' : 'HOT'}
                                    </span>
                                  )}
                                </span>
                                <ChevronRight className={`w-4 h-4 opacity-30 ${isRTL ? 'rotate-180' : ''}`} />
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {/* View All in Category Footer */}
                    {category.categoryMapping.women && category.categoryMapping.men && (
                      <div className="border-t border-gray-200 dark:border-gray-600 p-3 bg-gray-50 dark:bg-gray-900/50 rounded-b-2xl">
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleCategoryClick(key, null, 'women')}
                            className="flex-1 px-3 py-2.5 rounded-lg text-xs font-bold bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300 hover:bg-pink-200 dark:hover:bg-pink-900/50 transition-colors flex items-center justify-center gap-2"
                          >
                            <span className="w-2 h-2 rounded-full bg-pink-500"></span>
                            {isRTL ? 'كل النسائي' : "All Women's"}
                          </button>
                          <button
                            onClick={() => handleCategoryClick(key, null, 'men')}
                            className="flex-1 px-3 py-2.5 rounded-lg text-xs font-bold bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900/50 transition-colors flex items-center justify-center gap-2"
                          >
                            <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                            {isRTL ? 'كل الرجالي' : "All Men's"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        </div>
      </div>
    </div>
  );
}
